import { useContext } from "react";
import { Thead, THT, THTS } from "../../components";
import TableContext from "../Provider/TableContext";

function TableHead() {
  const { setOrder = () => {} } = useContext(TableContext);

  return (
    <Thead>
      <THTS txt="Customer" field="customer_id" setOrder={setOrder} />
      <THTS txt="Vehicle" field="vehicle_id" setOrder={setOrder} />
      <THTS txt="Driver" field="driver_id" setOrder={setOrder} />
      <THTS txt="Dispatcher" field="dispatcher_id" setOrder={setOrder} />
      <THTS txt="Order Date" field="order_date" setOrder={setOrder} />
      <THTS txt="Origin" field="origin" setOrder={setOrder} />
      <THTS txt="Destination" field="destination" setOrder={setOrder} />
      <THTS txt="Total Price" field="total_price" setOrder={setOrder} />
      <THT txt="Status" />
      <THT txt="Actions" />
    </Thead>
  );
}

export default TableHead;
